import { render, staticRenderFns } from "./LoginPageVK.vue?vue&type=template&id=1fe6aec8&scoped=true&"
import script from "./LoginPageVK.vue?vue&type=script&lang=js&"
export * from "./LoginPageVK.vue?vue&type=script&lang=js&"
import style0 from "./LoginPageVK.vue?vue&type=style&index=0&id=1fe6aec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe6aec8",
  null
  
)

export default component.exports